export default __webpack_public_path__ + "static/media/bg-set-favorite-sport.613a2e01.png";